// extracted by mini-css-extract-plugin
module.exports = {"footer":"index-footer-ce12f","footerTopText":"index-footerTopText-7bab3","footerBottomText":"index-footerBottomText-5b952"};